// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as Button$Showside from "./Button.bs.js";
import * as IconDown$Showside from "../icons/IconDown.bs.js";
import * as ScrollLock$Showside from "../utils/ScrollLock.bs.js";
import MergedRef from "@react-hook/merged-ref";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as PDPOptionButton$Showside from "./PDPOptionButton.bs.js";
import SmoothScrollIntoViewIfNeeded from "smooth-scroll-into-view-if-needed";
function makeOption(label, groupName, swatch, disabledOpt, hiddenOpt, id, alt, value) {
  var disabled = disabledOpt !== undefined ? disabledOpt : true;
  var hidden = hiddenOpt !== undefined ? hiddenOpt : false;
  return {
    id: id,
    groupName: groupName,
    label: label,
    value: value,
    alt: alt,
    swatch: Belt_Option.getWithDefault(swatch, /* NoSwatch */0),
    disabled: disabled,
    hidden: hidden
  };
}
function PDPSelect$Dropdown(Props) {
  var options = Props.options;
  var value = Props.value;
  var verticalDirectionOpt = Props.verticalDirection;
  var horizontalDirectionOpt = Props.horizontalDirection;
  var kindOpt = Props.kind;
  var circularOpt = Props.circular;
  var labelOpt = Props.label;
  var optionSize = Props.optionSize;
  var optionStyle = Props.optionStyle;
  var fullWidthOpt = Props.fullWidth;
  var onOptionClick = Props.onOptionClick;
  var verticalDirection = verticalDirectionOpt !== undefined ? verticalDirectionOpt : /* Bottom */1;
  var horizontalDirection = horizontalDirectionOpt !== undefined ? horizontalDirectionOpt : /* Right */1;
  var kind = kindOpt !== undefined ? kindOpt : /* Button */0;
  var circular = circularOpt !== undefined ? circularOpt : false;
  var label = labelOpt !== undefined ? labelOpt : "Select";
  var fullWidth = fullWidthOpt !== undefined ? fullWidthOpt : false;
  var match = React.useState(function () {
    return false;
  });
  var setIsOpen = match[1];
  var isOpen = match[0];
  var elRef = React.useRef(null);
  var options$1 = Belt_Array.keep(options, function (param) {
    return !param.hidden;
  });
  React.useEffect(function () {
    var handleClick = function (e) {
      var el = elRef.current;
      var elClicked = el == null ? false : el.contains(e.target);
      if (elClicked === false) {
        return Curry._1(setIsOpen, function (value) {
          return false;
        });
      }
    };
    document.addEventListener("click", handleClick);
    return function (param) {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  var renderOptions = function (options) {
    if (kind) {
      return Belt_Array.map(options, function (item) {
        var tmp = {
          value: item.swatch,
          disabled: item.disabled,
          selected: Caml_obj.equal(item.value, value),
          label: item.label,
          circular: circular,
          onClick: function (param) {
            var value = item.value;
            Curry._1(setIsOpen, function (param) {
              return false;
            });
            Curry._1(onOptionClick, value);
          },
          alt: Belt_Option.getWithDefault(item.alt, item.label),
          key: item.id
        };
        if (optionSize !== undefined) {
          tmp.size = Caml_option.valFromOption(optionSize);
        }
        return React.createElement(PDPOptionButton$Showside.SwatchButton.make, tmp);
      });
    } else {
      return Belt_Array.map(options, function (item) {
        var tmp = {
          label: item.label,
          disabled: item.disabled,
          selected: Caml_obj.equal(item.value, value),
          onClick: function (param) {
            var value = item.value;
            Curry._1(setIsOpen, function (param) {
              return false;
            });
            Curry._1(onOptionClick, value);
          },
          key: item.id
        };
        if (optionSize !== undefined) {
          tmp.size = Caml_option.valFromOption(optionSize);
        }
        if (optionStyle !== undefined) {
          tmp.style = Caml_option.valFromOption(optionStyle);
        }
        return React.createElement(PDPOptionButton$Showside.make, tmp);
      });
    }
  };
  var tmp;
  if (optionSize !== undefined) {
    switch (optionSize) {
      case /* Xs */0:
        tmp = /* Xs */0;
        break;
      case /* Sm */1:
        tmp = /* Sm */1;
        break;
      case /* Md */2:
        tmp = /* Md */2;
        break;
      case /* Lg */3:
      case /* Xl */4:
      case /* Xxl */5:
        tmp = /* Lg */3;
        break;
    }
  } else {
    tmp = /* Md */2;
  }
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(elRef),
    className: CSS$Showside.prefix(Cn.make(["relative flex gap-3", fullWidth ? "w-full" : ""]))
  }, React.createElement(Button$Showside.make, {
    children: null,
    className: CSS$Showside.prefix("gap-3"),
    kind: /* Gray */3,
    onClick: function (param) {
      Curry._1(setIsOpen, function (value) {
        return !value;
      });
    },
    size: tmp
  }, label, React.createElement(IconDown$Showside.make, {
    className: CSS$Showside.prefix(Cn.make([isOpen ? "transform rotate-180" : ""]))
  })), isOpen ? React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute", fullWidth ? "w-full max-w-146" : "w-146", horizontalDirection ? "right-0" : "left-0", verticalDirection ? "top-20" : "bottom-28"])),
    style: {
      zIndex: "10"
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute max-w-full p-5 bg-main shadow-lg", horizontalDirection ? "right-0" : "left-0", verticalDirection ? "top-0" : "bottom-0"]))
  }, React.createElement("div", {
    className: CSS$Showside.prefix("flex gap-3 flex-wrap")
  }, renderOptions(options$1)), React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 border border-primary opacity-5 pointer-events-none")
  }))) : null);
}
PDPSelect$Dropdown.displayName = "PDPSelect.Dropdown";
var Dropdown = {
  make: PDPSelect$Dropdown
};
function PDPSelect(Props) {
  var options = Props.options;
  var error = Props.error;
  var verticalDirectionOpt = Props.verticalDirection;
  var horizontalDirectionOpt = Props.horizontalDirection;
  var optionSize = Props.optionSize;
  var optionStyle = Props.optionStyle;
  var kindOpt = Props.kind;
  var circularOpt = Props.circular;
  var truncateAt = Props.truncateAt;
  var value = Props.value;
  var dataTestId = Props.dataTestId;
  var errorDataTestId = Props.errorDataTestId;
  var fwdRef = Props.fwdRef;
  var tabIndex = Props.tabIndex;
  var scrollIntoViewOnErrorOpt = Props.scrollIntoViewOnError;
  var onChange = Props.onChange;
  var verticalDirection = verticalDirectionOpt !== undefined ? verticalDirectionOpt : /* Bottom */1;
  var horizontalDirection = horizontalDirectionOpt !== undefined ? horizontalDirectionOpt : /* Right */1;
  var kind = kindOpt !== undefined ? kindOpt : /* Button */0;
  var circular = circularOpt !== undefined ? circularOpt : false;
  var scrollIntoViewOnError = scrollIntoViewOnErrorOpt !== undefined ? scrollIntoViewOnErrorOpt : false;
  var ref = React.useRef(null);
  var mergedRef = fwdRef !== undefined ? MergedRef(ref, fwdRef) : ref;
  React.useEffect(function () {
    if (scrollIntoViewOnError && Belt_Option.isSome(error)) {
      Belt_Option.forEach(Caml_option.nullable_to_opt(mergedRef.current), function (el) {
        SmoothScrollIntoViewIfNeeded(el, {
          behavior: "smooth",
          block: "center",
          inline: "nearest",
          scrollMode: "if-needed"
        });
      });
    }
  }, [error]);
  var setValue = function (nextValue) {
    if (Caml_obj.notequal(value, nextValue)) {
      return Belt_Option.forEach(onChange, function (cb) {
        Curry._1(cb, nextValue);
      });
    }
  };
  var options$1 = Belt_Array.keep(options, function (param) {
    return !param.hidden;
  });
  var visibleLabel = kind ? false : true;
  var truncateAt$1 = Belt_Option.map(truncateAt, function (truncateAt) {
    return Belt_Array.keepWithIndex(Belt_Array.reduce(Belt_Array.keepWithIndex(Belt_Array.map(Belt_Array.map(options$1, function (param) {
      return param.label;
    }), function (label) {
      return label.length;
    }), function (numCharacters, i) {
      return i < truncateAt;
    }), [], function (acc, curr) {
      var previousTotal = Belt_Array.reduce(acc, 0, function (acc2, curr2) {
        return acc2 + curr2 | 0;
      });
      var currentTotal = curr + previousTotal | 0;
      return Belt_Array.concat(acc, [currentTotal]);
    }), function (numCharacters, i) {
      if (numCharacters <= 50 || !visibleLabel) {
        return true;
      } else {
        return i === 0;
      }
    }).length;
  });
  var inlineOptions = truncateAt$1 !== undefined ? Belt_Array.slice(Belt_SortArray.stableSortBy(options$1, function (a, b) {
    var isA = Caml_obj.equal(a.value, value);
    var isB = Caml_obj.equal(b.value, value);
    var indexOfA = Belt_Array.getIndexBy(options$1, function (option) {
      return option.value === a.value;
    });
    var indexOfB = Belt_Array.getIndexBy(options$1, function (option) {
      return option.value === b.value;
    });
    if (isA && Caml_obj.greaterequal(indexOfA, truncateAt$1)) {
      return -1;
    } else if (isB && Caml_obj.greaterequal(indexOfB, truncateAt$1)) {
      return 1;
    } else {
      return 0;
    }
  }), 0, truncateAt$1) : options$1;
  var truncatedOptionsNum = options$1.length - inlineOptions.length | 0;
  var renderOptions = function (options) {
    if (kind) {
      return Belt_Array.map(options, function (item) {
        var tmp = {
          value: item.swatch,
          disabled: item.disabled,
          selected: Caml_obj.equal(item.value, value),
          label: item.label,
          circular: circular,
          onClick: function (param) {
            setValue(item.value);
          },
          dataId: item.value,
          alt: Belt_Option.getWithDefault(item.alt, item.label),
          key: item.id
        };
        if (optionSize !== undefined) {
          tmp.size = Caml_option.valFromOption(optionSize);
        }
        if (dataTestId !== undefined) {
          tmp.dataTestId = Caml_option.valFromOption(dataTestId);
        }
        if (tabIndex !== undefined) {
          tmp.tabIndex = Caml_option.valFromOption(tabIndex);
        }
        return React.createElement(PDPOptionButton$Showside.SwatchButton.make, tmp);
      });
    } else {
      return Belt_Array.map(options, function (item) {
        var tmp = {
          label: item.label,
          disabled: item.disabled,
          selected: Caml_obj.equal(item.value, value),
          dataId: item.value,
          onClick: function (param) {
            setValue(item.value);
          },
          key: item.id
        };
        if (optionSize !== undefined) {
          tmp.size = Caml_option.valFromOption(optionSize);
        }
        if (optionStyle !== undefined) {
          tmp.style = Caml_option.valFromOption(optionStyle);
        }
        if (dataTestId !== undefined) {
          tmp.dataTestId = Caml_option.valFromOption(dataTestId);
        }
        if (tabIndex !== undefined) {
          tmp.tabIndex = Caml_option.valFromOption(tabIndex);
        }
        return React.createElement(PDPOptionButton$Showside.make, tmp);
      });
    }
  };
  var tmp;
  if (truncateAt$1 !== undefined) {
    if (Caml_obj.equal(inlineOptions, [])) {
      var tmp$1 = {
        options: options$1,
        verticalDirection: verticalDirection,
        horizontalDirection: horizontalDirection,
        kind: kind,
        circular: circular,
        label: Belt_Option.getWithDefault(value, "--"),
        fullWidth: true,
        onOptionClick: function (value) {
          setValue(value);
        }
      };
      if (value !== undefined) {
        tmp$1.value = value;
      }
      if (optionSize !== undefined) {
        tmp$1.optionSize = Caml_option.valFromOption(optionSize);
      }
      if (optionStyle !== undefined) {
        tmp$1.optionStyle = Caml_option.valFromOption(optionStyle);
      }
      tmp = React.createElement(PDPSelect$Dropdown, tmp$1);
    } else if (truncatedOptionsNum > 0) {
      var tmp$2 = {
        options: options$1,
        verticalDirection: verticalDirection,
        horizontalDirection: horizontalDirection,
        kind: kind,
        circular: circular,
        label: "+" + String(truncatedOptionsNum) + "",
        onOptionClick: function (value) {
          setValue(value);
        }
      };
      if (value !== undefined) {
        tmp$2.value = value;
      }
      if (optionSize !== undefined) {
        tmp$2.optionSize = Caml_option.valFromOption(optionSize);
      }
      if (optionStyle !== undefined) {
        tmp$2.optionStyle = Caml_option.valFromOption(optionStyle);
      }
      tmp = React.createElement(PDPSelect$Dropdown, tmp$2);
    } else {
      tmp = null;
    }
  } else {
    tmp = null;
  }
  var tmp$3;
  if (error !== undefined) {
    var tmp$4 = {
      children: React.createElement("div", {
        className: CSS$Showside.prefix("text-red-600 pt-1")
      }, error)
    };
    if (errorDataTestId !== undefined) {
      tmp$4.dataTestId = Caml_option.valFromOption(errorDataTestId);
    }
    tmp$3 = React.createElement(DataAttribute$Showside.make, tmp$4);
  } else {
    tmp$3 = null;
  }
  return React.createElement(ScrollLock$Showside.make, {
    children: null
  }, React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(mergedRef),
    className: CSS$Showside.prefix(Cn.make(["flex gap-3 flex-wrap", Belt_Option.isSome(error) ? "animate-wiggle" : ""]))
  }, renderOptions(inlineOptions), tmp), tmp$3);
}
PDPSelect.displayName = "PDPSelect";
var make = PDPSelect;
export { makeOption, Dropdown, make };
/* react Not a pure module */